import React from 'react';
import { Card } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import 'highcharts/highcharts-more';
import { getBubbleChartOptions } from './bubble-chart-options';
import type { IBubbleChartProps } from './types';

export const BubbleChart: React.FC<IBubbleChartProps> = (props) => {
  const { title, data, xAxisTitle, yAxisTitle, seriesName } = props;

  const options = getBubbleChartOptions({ data, xAxisTitle, yAxisTitle, seriesName });

  return (
    <Card title={title}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Card>
  );
};
